import {cityCodeReviewInput, hotelAreaReviewInput} from '@stencil/hotels-review-reducer';
import {createSelector} from 'reselect';

import {AppState} from '../../../../verticals/hotels-dweb/src/shared/store';

export const commonSelector = (state: AppState) => state.common;

export const hotelsPartnerFn = createSelector(commonSelector, item => item.partner);

export const metaPartnerSelectorFn = createSelector(commonSelector, item => item.metaPartner);

export const commonSelectorFn = createSelector(commonSelector, item => item);

export const countrySelectorFn = createSelector(commonSelectorFn, item => item.country);

export const roomStringSelectorFn = createSelector(commonSelectorFn, item => item.roomString);

export const checkoutSelectorFn = createSelector(commonSelectorFn, item => item.checkout);

export const checkinSelectorFn = createSelector(commonSelectorFn, item => item.checkin);

export const destinationSelectorFn = createSelector(commonSelectorFn, item => item.destination);

export const cityIdSelectorFn = createSelector(destinationSelectorFn, item => item._id);

// this will be hotel id on details and review
export const hotelIdSelectorFnFromCommon = createSelector(destinationSelectorFn, item => item._id);

export const selectedHotelSelector = createSelector(commonSelector, item => item.selectedHotel);
export const selectedPropertySelector = selectedHotelSelector;
export const goingForwardPropertyIdSelector = createSelector(
  selectedHotelSelector,
  item => item?.propertyId,
);
export const selectedPropertyNameSelector = createSelector(
  selectedHotelSelector,
  selectedProperty => selectedProperty.propertyName || '',
);

export const selectedPropertyReviewType = createSelector(
  selectedHotelSelector,
  selectedProperty => selectedProperty?.reviewType || null,
);

export const autosuggestOpenedBySelector = createSelector(
  commonSelector,
  item => item.autosuggestOpenedBy,
);

export const calenderProgressiveSearchFormOpenedBySelector = createSelector(
  commonSelector,
  item => item.calenderProgressiveSearchFormOpenedBy,
);

export const pageHeaderSearchWidgetOpenStateSelector = createSelector(
  commonSelector,
  item => item.isPageHeaderSearchWidgetOpen,
);

// should extract out segment slider into separate reducer altogether
export const segmentSliderSelectorFn = createSelector(
  commonSelectorFn,
  item => item.segmentSliderApi,
);

export const reviewPageSrpUrlParamsSelectorFn = createSelector(
  checkinSelectorFn,
  checkoutSelectorFn,
  roomStringSelectorFn,
  destinationSelectorFn,
  hotelAreaReviewInput,
  cityCodeReviewInput,
  (checkin, checkout, roomString, destination, hotelArea, cityCode) => ({
    checkin,
    checkout,
    roomString,
    destination: {...destination, _id: cityCode || destination._id, n: hotelArea || destination.n},
  }),
);
